<template>
    <div class="avatar">
        <InlineSVG :src="require(`./assets/avatar-default.svg`)"/>
    </div>
</template>

<script>
import Vue from 'vue'
import InlineSVG from 'vue-inline-svg'

export default {
    name: `UserAvatar`,
    components: {
        InlineSVG
    }
}
</script>

<style lang="scss" scoped>
%avatar-vars {
    --avatar-background: var(--yank);
    --avatar-border: transparent;

    &:hover {
        --avatar-border: var(--payne-fire);
    }

    &:focus {
        --avatar-background: var(--payne-fire);
        --avatar-border: var(--payne-fire);
    }
}

.avatar {
    @extend %avatar-vars;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    color: white;
    background-color: var(--avatar-background);
    border: 2px solid;
    border-color: var(--avatar-border);
    border-radius: 50%;
    transition: background 240ms, border 240ms;
}

svg {
    width: 16px;
}
</style>
